import { useEffect, useMemo, useState, useCallback } from "react"
import { useParams, useSearchParams } from "react-router-dom"

import { useRoute } from "providers/route"
import { useVenue } from "providers/venue"

export const useDirection = () => {
  const [isError, setIsError] = useState(false)
  const { findRoute, clearRoute, route, findElevatorPreferredRoute } =
    useRoute()
  const { transformLocationToFeature, relationshipGraphLoaded } = useVenue()
  const { origin: originParams, destination: destinationParams } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const origin = useMemo(
    () => transformLocationToFeature(originParams),
    [originParams, transformLocationToFeature]
  )

  const destination = useMemo(
    () => transformLocationToFeature(destinationParams),
    [destinationParams, transformLocationToFeature]
  )

  const elevatorPreferredMode = useMemo(() => {
    const isAvoidSteps = searchParams.get("avoidSteps")
    return isAvoidSteps === "true"
  }, [searchParams])

  const toggleElevatorPreference = useCallback(() => {
    const currentParams = Object.fromEntries(searchParams.entries())
    setSearchParams({ ...currentParams, avoidSteps: !elevatorPreferredMode })
  }, [elevatorPreferredMode, searchParams, setSearchParams])

  useEffect(() => {
    if (!relationshipGraphLoaded) return
    try {
      if (origin && destination && !elevatorPreferredMode) {
        findRoute(origin, destination)
      }
      if (origin && destination && elevatorPreferredMode) {
        findElevatorPreferredRoute(origin, destination)
      }
    } catch (error) {
      setIsError(true)
    }
    return () => clearRoute()
  }, [
    origin,
    destination,
    relationshipGraphLoaded,
    clearRoute,
    findRoute,
    elevatorPreferredMode,
    findElevatorPreferredRoute,
  ])

  return {
    route,
    isError,
    origin,
    destination,
    // Function
    elevatorPreferredMode,
    toggleElevatorPreference,
  }
}
